import { InputNumber } from "antd";
import React from "react";
import * as S from "./style";

interface Props {
  disabled?: boolean;
  onChange?: (e: number) => void;
  handleUp?: () => void;
  handleDown?: () => void;
  max?: number;
  value?: number;
}

function InputNumberNew({
  disabled,
  onChange,
  max = 0,
  handleUp,
  handleDown,
  value = 1,
}: Props) {
  return (
    <S.Container>
      <div
        className="btn-count minus"
        onClick={() => {
          if (value > 1 && !disabled) {
            handleDown?.();
          }
        }}
      >
        -
      </div>
      <InputNumber
        min={1}
        max={max}
        value={value}
        onChange={(e) => {
          // Cap value to max if exceeded
          const inputValue = e || 0;
          const clampedValue = max > 0 ? Math.min(Math.max(1, inputValue), max) : inputValue;
          onChange?.(clampedValue);
        }}
        onKeyDown={(e) => {
          // Allow control keys
          if (["Backspace", "Delete", "Tab", "ArrowLeft", "ArrowRight"].includes(e.key)) {
            return;
          }
          // Block non-numeric keys
          if (!/^\d$/.test(e.key)) {
            e.preventDefault();
            return;
          }
          // Check if new value would exceed max
          const input = e.currentTarget as HTMLInputElement;
          const currentValue = input.value.replace(/^0+/, "") || "0";
          const selectionStart = input.selectionStart ?? currentValue.length;
          const selectionEnd = input.selectionEnd ?? currentValue.length;
          const newValue = currentValue.slice(0, selectionStart) + e.key + currentValue.slice(selectionEnd);
          if (max > 0 && parseInt(newValue, 10) > max) {
            e.preventDefault();
          }
        }}
        formatter={(
          value: number | undefined,
          _info?: { userTyping: boolean; input: string }
        ) => (value !== undefined ? value.toString().padStart(2, "0") : "00")}
        disabled={disabled}
        controls={false}
      />
      <div
        className="btn-count plus"
        onClick={() => {
          if (!disabled && value < max) {
            handleUp?.();
          }
        }}
      >
        +
      </div>
    </S.Container>
  );
}

export default InputNumberNew;
